import Insights from "./component";

export default Insights;
